export const contourType = {
    "DETAIL": "Деталь",
    "GROOVE": "Паз",
    "NOTCH": "Внутрений контур",
    "QUARTER": "Четверть",
    "CUT": "Срез",
    "EDGE": "Кромка",
}